'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MainMenu = exports.ENGAGEMENT_ELEMENTS = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _tracking = require('@spp/tracking');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uiInternalLink = require('@spp/ui-internal-link');

var _uiInternalLink2 = _interopRequireDefault(_uiInternalLink);

var _reactRedux = require('react-redux');

var _UserMenu = require('../UserMenu');

var _UserMenu2 = _interopRequireDefault(_UserMenu);

var _SiteMap = require('../SiteMap');

var _SiteMap2 = _interopRequireDefault(_SiteMap);

var _coreNavigationUi = require('../../redux/core-navigation-ui');

var _svg = require('../svg');

var _props2 = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    MENU_SITEMAP: 'MainMenu_SitemapToggle',
    MENU_SECTION: 'MainMenu_Section',
    MENU_SUBSECTION: 'MainMenu_SubSection',
    MENU_ITEM: 'MainMenu_Item'
}; /*
   eslint-disable
   react/prop-types,
   import/no-named-as-default
   */

var MainMenu = exports.MainMenu = function (_Component) {
    (0, _inherits3.default)(MainMenu, _Component);

    function MainMenu() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MainMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MainMenu.__proto__ || (0, _getPrototypeOf2.default)(MainMenu)).call.apply(_ref, [this].concat(args))), _this), _this.toggleSitemap = function () {
            _this.props.dispatch(_coreNavigationUi.actions.toggleSitemap());
        }, _this.renderPublicationMenu = function (theme, engagement) {
            return _this.props.mainMenu.publicationMenu.map(function (item) {
                return _react2.default.createElement(
                    'li',
                    { key: item.name },
                    _react2.default.createElement(
                        _uiInternalLink2.default,
                        {
                            link: item.url,
                            className: theme.publicationLink,
                            onClick: function onClick(event) {
                                event.preventDefault();

                                _tracking.util.actionThenRelocateWithTimeout(engagement({
                                    elementIdentifier: ENGAGEMENT_ELEMENTS.MENU_ITEM,
                                    meta: { name: item.name, event: event }
                                }), item.url);
                            },
                            enableSinglePage: true
                        },
                        item.name
                    )
                );
            });
        }, _this.renderSectionHeaderOrLink = function (item, isLast, engagement, theme) {
            if (isLast && item.siteMap) {
                return _react2.default.createElement(
                    'button',
                    {
                        onClick: function onClick(event) {
                            event.preventDefault();

                            engagement({
                                elementIdentifier: ENGAGEMENT_ELEMENTS.MENU_SITEMAP,
                                meta: { name: 'SITEMAP', event: event }
                            });

                            _this.toggleSitemap();
                        },
                        className: (0, _classnames2.default)('sitemapTrigger', theme.sectionLink)
                    },
                    item.name
                );
            }

            if (item.url) {
                return _react2.default.createElement(
                    _uiInternalLink2.default,
                    {
                        onClick: function onClick(event) {
                            event.preventDefault();

                            _tracking.util.actionThenRelocateWithTimeout(engagement({
                                elementIdentifier: ENGAGEMENT_ELEMENTS.MENU_SECTION,
                                meta: { name: item.name, event: event }
                            }), item.url);
                        },
                        className: theme.sectionLink,
                        link: item.url,
                        enableSinglePage: true
                    },
                    item.name
                );
            }

            return _react2.default.createElement(
                'span',
                { className: theme.sectionTitle },
                item.name
            );
        }, _this.renderSectionsNavigationMenu = function (areaNavClass, engagement) {
            var _this$props = _this.props,
                mainMenu = _this$props.mainMenu,
                sectionsMenu = _this$props.sectionsMenu,
                theme = _this$props.theme,
                subSectionsState = _this$props.subSectionsState;

            var sectionsList = sectionsMenu.filter(function (item) {
                return item.mainMenu;
            });

            var renderSections = function renderSections(sections) {
                return sections.map(function (item, index) {
                    var isLast = index === sections.length - 1;
                    var submenuOpened = subSectionsState[item.name];

                    var itemClassName = submenuOpened ? theme['sectionItem-submenuOpen'] : theme.sectionItem;
                    var subsectionsClassName = submenuOpened ? theme['menuSubsections-submenuOpen'] : theme.menuSubsections;

                    return _react2.default.createElement(
                        'li',
                        { key: item.name, className: itemClassName },
                        _react2.default.createElement(
                            'div',
                            { className: theme.sectionNameContainer },
                            _this.renderSectionHeaderOrLink(item, isLast, engagement, theme),
                            item.subSections && _react2.default.createElement(
                                'button',
                                {
                                    className: (0, _classnames2.default)('cn-section-' + item.name.toLowerCase() + '-trigger', theme.sectionTrigger),
                                    onClick: function onClick() {
                                        return _this.props.dispatch(_coreNavigationUi.actions.toggleSection(item.name));
                                    }
                                },
                                _react2.default.createElement(_svg.ChevronDownMainMenuSvg, {
                                    icon: mainMenu.svg.chevron,
                                    title: mainMenu.svg.chevron.title
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'ul',
                            { className: subsectionsClassName },
                            _this.renderSubSections({
                                theme: theme,
                                subsections: item.subSections
                            }, engagement)
                        )
                    );
                });
            };

            return _react2.default.createElement(
                'ul',
                {
                    className: areaNavClass,
                    'aria-label': 'sections menu'
                },
                renderSections(sectionsList)
            );
        }, _this.renderSectionsSitemap = function (wrapperClass, engagement) {
            var _this$props2 = _this.props,
                sectionsMenu = _this$props2.sectionsMenu,
                mainMenu = _this$props2.mainMenu,
                theme = _this$props2.theme,
                sitemapOpened = _this$props2.sitemapOpened;

            var item = sectionsMenu[sectionsMenu.length - 1];

            if (!item.siteMap) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                {
                    className: wrapperClass,
                    'aria-label': 'sitemap'
                },
                _react2.default.createElement(_SiteMap2.default, {
                    parentElement: item,
                    chevronSvg: mainMenu.svg.chevron,
                    theme: theme,
                    isSitemapOpen: sitemapOpened,
                    onSitemapClose: function onSitemapClose(event) {
                        event.preventDefault();

                        engagement({
                            elementIdentifier: ENGAGEMENT_ELEMENTS.MENU_SITEMAP,
                            meta: { name: 'SITEMAP', event: event }
                        });

                        _this.toggleSitemap();
                    }
                })
            );
        }, _this.renderSubSections = function (_ref2, engagement) {
            var subsections = _ref2.subsections,
                theme = _ref2.theme;
            return subsections && subsections.length > 0 && subsections.map(function (item) {
                var linkClass = item.isNew ? theme['subsectionLink-new'] : theme.subsectionLink;
                return _react2.default.createElement(
                    'li',
                    { key: item.name, className: theme.subsectionItem },
                    _react2.default.createElement(
                        _uiInternalLink2.default,
                        {
                            link: item.url,
                            className: linkClass,
                            onClick: function onClick(event) {
                                event.preventDefault();

                                _tracking.util.actionThenRelocateWithTimeout(engagement({
                                    elementIdentifier: ENGAGEMENT_ELEMENTS.MENU_SUBSECTION,
                                    meta: { name: item.name, event: event }
                                }), item.url);
                            },
                            enableSinglePage: true
                        },
                        item.name
                    )
                );
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(MainMenu, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                mainMenu = _props.mainMenu,
                theme = _props.theme,
                sitemapOpened = _props.sitemapOpened,
                mainMenuOpened = _props.mainMenuOpened,
                engagement = _props.engagement,
                attributes = _props.attributes;

            var mainMenuClass = mainMenuOpened ? theme['mainMenu-menuOpen'] : theme.mainMenu;
            var innerContainerClass = mainMenuOpened ? theme['innerContainer-menuOpen'] : theme.innerContainer;
            var areaNavClass = sitemapOpened ? theme['menuAreaNav-sitemapOpen'] : theme.menuAreaNav;
            var wrapperClass = sitemapOpened ? theme['sitemapWrapper-sitemapOpen'] : theme.sitemapWrapper;
            var menuGroupClass = sitemapOpened ? theme['menuGroupInfo-sitemapOpen'] : theme.menuGroupInfo;

            var widgets = mainMenu.userMenu.widgets;
            var userMenuWidgetDefined = widgets && widgets.UserMenuWidget;

            return _react2.default.createElement(
                'div',
                { role: 'navigation', 'aria-label': 'global navigation', className: mainMenuClass },
                _react2.default.createElement(
                    'div',
                    { className: theme.outerContainer },
                    _react2.default.createElement(
                        'div',
                        { className: innerContainerClass },
                        _react2.default.createElement(
                            'div',
                            { className: theme.innerContainerWrapper },
                            _react2.default.createElement(
                                'div',
                                { className: theme.menuGroup },
                                this.renderSectionsNavigationMenu(areaNavClass, engagement),
                                this.renderSectionsSitemap(wrapperClass, engagement)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: menuGroupClass },
                                _react2.default.createElement(_UserMenu2.default, {
                                    theme: theme,
                                    userLoggedInSvg: mainMenu.svg.userLoggedIn,
                                    userMenu: mainMenu.userMenu,
                                    engagement: engagement,
                                    attributes: attributes
                                }),
                                !userMenuWidgetDefined && _react2.default.createElement(
                                    'ul',
                                    { className: theme.publicationMenu, 'aria-label': 'publication menu' },
                                    this.renderPublicationMenu(theme, engagement)
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return MainMenu;
}(_react.Component);

if (process.env.NODE_ENV !== 'production') {
    MainMenu.propTypes = {
        attributes: _propTypes2.default.func,
        engagement: _propTypes2.default.func,
        dispatch: _propTypes2.default.func.isRequired,
        mainMenu: _propTypes2.default.shape(_props2.mainMenuProps).isRequired,
        mainMenuOpened: _propTypes2.default.bool.isRequired,
        sectionsMenu: _propTypes2.default.arrayOf(_propTypes2.default.shape(_props2.sectionMenuObjectProps)).isRequired,
        sitemapOpened: _propTypes2.default.bool.isRequired,
        theme: _propTypes2.default.shape({
            innerContainer: _propTypes2.default.string,
            innerContainerWrapper: _propTypes2.default.string,
            menuAreaNav: _propTypes2.default.string,
            menuGroup: _propTypes2.default.string,
            menuGroupInfo: _propTypes2.default.string,
            menuSubsections: _propTypes2.default.string,
            mobileOnly: _propTypes2.default.string,
            new: _propTypes2.default.string,
            outerContainer: _propTypes2.default.string,
            publicationMenu: _propTypes2.default.string,
            publicationItem: _propTypes2.default.string,
            publicationLink: _propTypes2.default.string,
            root: _propTypes2.default.string,
            sectionItem: _propTypes2.default.string,
            sectionLink: _propTypes2.default.string,
            sectionNameContainer: _propTypes2.default.string,
            sectionTitle: _propTypes2.default.string,
            sectionTrigger: _propTypes2.default.string,
            sitemapWrapper: _propTypes2.default.string,
            subsectionItem: _propTypes2.default.string,
            subsectionLink: _propTypes2.default.string
        })
    };
}

MainMenu.defaultProps = {
    theme: {},
    attributes: function attributes() {},
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    sitemapOpened: false,
    mainMenuOpened: false
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        subSectionsState: state.coreNavigationUI.subsections,
        sitemapOpened: state.coreNavigationUI.main.sitemapOpened,
        mainMenuOpened: state.coreNavigationUI.main.mainMenuOpened
    };
})(MainMenu);
//# sourceMappingURL=MainMenu.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MainMenu/MainMenu.js
 ** module id = 316
 ** module chunks = 0
 **/